import { Observable, merge } from "rxjs";
import { catchError, map, shareReplay, startWith, switchMap, tap } from "rxjs/operators";
import { ProblemDetailsHandler } from "../../services/home-ia/problem-details-handler.service";
import { LoadState } from "./home.component.state";

export class HomeLoadStateFactory {
  constructor(private readonly errors: ProblemDetailsHandler) {}

  create<T>(
    refresh$: Observable<void>,
    load: () => Observable<T>,
    isEmpty: (data: T) => boolean = () => false
  ): Observable<LoadState<T>> {
    return refresh$.pipe(
      startWith(undefined),
      switchMap(() => load().pipe(
        map((data) => ({
          data, loading: false, error: null, empty: isEmpty(data), stale: false, lastUpdated: Date.now()
        }) as LoadState<T>),
        startWith({
          data: null, loading: true, error: null, empty: false, stale: false, lastUpdated: null
        } as LoadState<T>),
        catchError((error) => this.errors.handle(error).pipe(
          map((uxError) => ({
            data: null, loading: false, error: uxError, empty: false, stale: false, lastUpdated: null
          }) as LoadState<T>)
        ))
      )),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  createPatched<T>(
    loadState$: Observable<LoadState<T>>,
    patch$: Observable<LoadState<T>>,
    onState: (state: LoadState<T>) => void
  ): Observable<LoadState<T>> {
    return merge(loadState$, patch$).pipe(
      tap(onState),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }
}
